import {
  type DrillProgress,
  hidesCharacter,
} from "../handwriting/xiezi-stages.js";

/**
 * The cue under the line over a hanzi writing square, saying what the
 * character in it is.
 *
 * `partials/lianxi/drill.html` draws one cue per character, hidden, marked
 * `data-cb-lianxi-cue` with the character it describes. This shows the one for
 * the character in the square and hides the others, and marks it
 * `data-cb-xiezi-recall` while the character is written from memory, which
 * `modules/lianxi` reads to put a gap in the List word where the character
 * was. `lianxi-round-view.ts` calls it after every move between characters,
 * beside `lianxi-places.ts`.
 */

/**
 * Show the cue for the character in the square.
 * @param items - The row's items, one per character, in the Exercise's order.
 * @param progress - Where the reader is with each character, in the same order.
 * @param current - Which character is in the square, or nothing once every
 * character is finished, which hides every cue.
 */
export function showCues(
  items: readonly HTMLElement[],
  progress: readonly DrillProgress[],
  current: number | undefined,
): void {
  const block = items[0]?.closest("[data-cb-lianxi-xiezi]");
  const item = current === undefined ? undefined : items[current];
  const held = current === undefined ? undefined : progress[current];
  const character = item?.dataset["cbXieziCharacter"];

  for (const cue of block?.querySelectorAll<HTMLElement>(
    "[data-cb-lianxi-cue]",
  ) ?? []) {
    const shown =
      character !== undefined && cue.dataset["cbLianxiCue"] === character;

    cue.hidden = !shown;
    cue.toggleAttribute(
      "data-cb-xiezi-recall",
      shown && held !== undefined && hidesCharacter(held),
    );
  }
}
